import localforage from 'localforage';
import { decryptWithAES, encryptWithAES } from '../../../../utils/cryptography';
import { GLOBAL_WINDOW_STORE_KEY } from '../../../app/const';
import { PersistedStorage } from './types';

function getSyncStorage(requestKey: string) {
	return (window[GLOBAL_WINDOW_STORE_KEY][requestKey] as PersistedStorage) || null;
}

async function getAsyncStorage(requestKey: string) {
	const storeValue = await localforage.getItem<string>(requestKey);
	return storeValue ? decryptWithAES<PersistedStorage>(storeValue, requestKey) : null;
}

async function getStorage(requestKey: string): Promise<PersistedStorage | null> {
	const syncData = getSyncStorage(requestKey);

	if (syncData !== null) {
		return syncData;
	}

	return getAsyncStorage(requestKey);
}

function setAsyncStorageValue(requestKey: string, value: PersistedStorage) {
	localforage.setItem(requestKey, encryptWithAES(value, requestKey));
}

function setSyncStorage(requestKey: string, storageValue: PersistedStorage) {
	window[GLOBAL_WINDOW_STORE_KEY][requestKey] = storageValue;
}

function setStorage(requestKey: string, storageValue: PersistedStorage) {
	setAsyncStorageValue(requestKey, storageValue);
	setSyncStorage(requestKey, storageValue);
}

export { getAsyncStorage, getSyncStorage, setAsyncStorageValue, setSyncStorage, getStorage, setStorage };
